import {Component, OnDestroy, OnInit} from '@angular/core';
import {NgIf} from "@angular/common";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {ActivatedRoute, Router, RouterLink} from "@angular/router";
import {AuthService, RequestPasswordResetResult, SignInResult} from "../auth.service";
import {Subscription} from "rxjs";
import {PasswordFieldState} from "../../common/password-field-state";
import {AlertComponent} from "../../common/alert/alert.component";
import {AlertService} from "../../common/alert/alert.service";

@Component({
    selector: 'app-login',
    imports: [NgIf, ReactiveFormsModule, RouterLink, AlertComponent],
    templateUrl: './sign-in.component.html',
    styleUrls: ['./sign-in.component.css'],
    providers: [AlertService]
})
export class SignInComponent implements OnDestroy, OnInit {
    private subscriptions: Subscription[] = [];
    private formBuilder = new FormBuilder().nonNullable

    private email = this.formBuilder.control(
        "",
        {validators: [Validators.email]}
    )
    private password = this.formBuilder.control("")

    loginForm = new FormGroup({
        email: this.email,
        password: this.password,
    });

    resetForm = new FormGroup({
        email: this.email
    });

    passwordState = new PasswordFieldState()
    isLoading: boolean = false;
    loginMode: boolean = true;

    constructor(private authService: AuthService, private router: Router, private route: ActivatedRoute, private alertService: AlertService) {

    }

    ngOnInit() {
        this.subscriptions.push(
            this.authService.user.subscribe(user => {
                if (user) {
                    const redirectUrl = this.route.snapshot.queryParamMap.get('redirectUrl') ?? "rounds";
                    if (this.isRedirectUrlValid(redirectUrl)) {
                        if (redirectUrl.startsWith('http')) {
                            window.location.href = redirectUrl;
                        } else {
                            this.router.navigateByUrl(redirectUrl);
                        }
                    } else {
                        this.router.navigateByUrl("rounds");
                    }
                }
            })
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe())
    }

    signIn() {
        this.clearState();
        this.isLoading = true;
        this.subscriptions.push(
            this.authService.signInWithEmail(this.email.value, this.password.value)
                .subscribe(result => {
                    this.clearState();
                    if (result != SignInResult.Success) {
                        this.alertService.showAlert('danger', 'Wrong email or password');
                    }
                })
        )
    }

    reset() {
        this.clearState();
        this.isLoading = true;
        this.subscriptions.push(
            this.authService
                .requestPasswordReset(this.email.value)
                .subscribe(result => {
                    this.clearState();
                    if (result == RequestPasswordResetResult.Requested) {
                        this.alertService.showAlert('success', 'Password reset email sent');
                        this.loginMode = true;
                    } else {
                        this.alertService.showAlert('danger', 'Password reset failed');
                    }
                })
        )
    }

    onForgotPassword() {
        this.clearState();
        this.loginMode = false;
    }

    toLoginMode() {
        this.clearState();
        this.loginMode = true;
    }

    private clearState() {
        this.alertService.clearAlerts();
        this.isLoading = false;
    }

    private isRedirectUrlValid(redirectUrl: any) {
        if (redirectUrl.startsWith("/")) {
            return true
        }
        try {
            return new URL(redirectUrl).hostname.endsWith("dashboard.15club.golf")
        } catch (e) {
            return false
        }
    }
}
